import React, { Component } from 'react';
import { observer } from 'mobx-react';

import SignInPage from './Signin';
import VendorPage from './vendor/VendorPage'
import FunAdmin from './admin/FunAdmin'

const windowWidth = window.innerWidth;

const Home = observer(class Home extends Component {

  componentDidMount() {
    // console.log('home component',this.props);
    // this.props.myStores.auth.signIn();
  }

  render() {
    let { mainStore } = this.props.myStores;
    let { authUser, authenticated, isAdmin } = mainStore;

    if(!authenticated) {

      //  NEED LOGIN COMPONENTS
      return (
        <SignInPage { ...this.props } />
      )

    }

    return (
      <div>
        {
          isAdmin
          ? <FunAdmin {...this.props} />

          : <VendorPage {...this.props} />
        }
      </div>
    )

  }

})

const styles = {
  header: {
    marginTop: '5vh'
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home.component.js